<template>
	
  <v-layout row justify-center>
    

    <v-dialog
      v-model="dialog"
      max-width="290"

    >
      <v-card>
        <v-card-title class="headline">{{
        	this.translater.__(
        		'Are you sure you want to delete the selected user?', 'users'
        	)
        }}</v-card-title>

        <v-card-text>
          {{
          	this.$store.getters['users/selected'].username
          }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="dismiss()"
          >
            {{

            	translater.__("No")
            }}
          </v-btn>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="destroy()"
          >
            {{

            	translater.__("Yes")
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
	export default {
		name: 'UsersDelete',
		data() {
			return {
				//dialog: true
			}
		},
		
		
		created()
		{
			
		},

		methods: {
			dismiss()
			{
				
				this.dialog = !this.dialog;
			},

			destroy()
			{
				this.dismiss();
				this.$store.dispatch('users/destroy')
				.then((res) => {
					this.$store.dispatch('success/setMessage', this.$store.getters['translate/translater'].__('User deleted successfully', 'users'));

				this.$store.dispatch('users/indexDT');	

					setTimeout(() => {
						this.$store.dispatch('success/setMessage', undefined)
					}, 2000)
				})
				.catch((err) => {
					this.$store.dispatch('error/setError', 
					this.$store.getters['translate/translater']
					.__('Error deleting user', 'users'));

					setTimeout(() => {
						this.$store.dispatch('error/setError', undefined)
					}, 2000)
				})
			}
		},

		computed: {
			dialog: {
				get: function()
				{
					return this.$store.getters['users/showDeleteConfirmation'];
				},

				set: function(value)
				{
					this.$store.dispatch('users/setShowDeleteConfirmation', value);
				}
			},

			translater: {
				get: function()
				{
					return this.$store.getters['translate/translater'];
				}
			}
		}

		
	}
</script>
